import { Trans, useTranslation } from "next-i18next";

import { AccordionItem } from "@sellernote/ui/src/sds-v2/components/Accordion";

import LandingSectionFaq from "../../../components/landing/LandingSectionFaq";

import DAPCaseAnswer from "./DAPCaseAnswer";
import Styled from "./index.styles";

export default function FaqSection() {
  const { t } = useTranslation(["page-sourcing"]);

  const FAQ_SECTION_DATA: AccordionItem[] = [
    {
      title: (
        <Trans i18nKey="page-sourcing:할인쿠폰_발급_요구조건이_궁금해요." />
      ),
      desc: (
        <Styled.faqContainer>
          <p>
            <Trans i18nKey="page-sourcing:_쉽다_를_통해_알리바바닷컴을_접속하고__접속_후_15일_이내에_신규_주문한_발주_건에_대해_결제를_진행하시면_쉽다에서__결제액_X_3__를_물류비_할인쿠폰으로_제공해드리는_프로모션을_진행합니다." />
          </p>

          <div>
            <li>
              1.{" "}
              <Trans i18nKey="page-sourcing:프로모션_기간__2024년_12월_27일___종료_시까지" />
            </li>
          </div>

          <div>
            <li>
              2. <Trans i18nKey="page-sourcing:발급_요구조건" />
            </li>
            <div className="requirement">
              <Trans i18nKey="page-sourcing:쉽다를_통해_알리바바닷컴_접속_이후__신규_주문_및_결제한_내역에_대해서만_인정됩니다." />

              <ul className="description">
                <div>
                  <em className="description-comment-1">
                    <Trans i18nKey="page-sourcing:쉽다를_통해_알리바바닷컴을_접속하고__신규_주문_및_결제를_진행해주셔야_합니다." />
                  </em>

                  <li>
                    -{" "}
                    <Trans i18nKey="page-sourcing:알리바바닷컴에서_이미_주문_건_결제되지_않은_을_생성한_경우에는_결제를_진행하셔도_물류비_혜택을_받아보실_수_없습니다." />
                    <div className="comment">
                      &nbsp;&nbsp; (
                      <Trans i18nKey="page-sourcing:신규_주문_건만_인정됩니다._이전_건을_취소하시고_다시_주문하는_경우는_인정됩니다." />
                      )
                    </div>
                  </li>
                  <li>
                    -{" "}
                    <Trans i18nKey="page-sourcing:신규__기존_가입자_모두_이용_가능합니다." />
                  </li>
                  <li>
                    -{" "}
                    <Trans i18nKey="page-sourcing:알리바바닷컴으로부터_결제한_내역이_쉽다에게_전달됩니다." />
                  </li>
                  <li>
                    -{" "}
                    <Trans i18nKey="page-sourcing:내역이_확인된_이후__쿠폰_발행_이_이뤄집니다._결제시기와_시간_차가_있을_수_있습니다." />
                  </li>
                </div>

                <em className="description-comment-2">
                  <Trans i18nKey="page-sourcing:결제수단은_무관하나__반드시_알리바바닷컴_내에서_결제를_진행해주셔야_합니다." />
                </em>
              </ul>
            </div>
          </div>

          <div>
            <li>
              3. <Trans i18nKey="page-sourcing:할인액__결제액_X_3_" />
            </li>
            <li>
              4.{" "}
              <Trans i18nKey="page-sourcing:할인쿠폰_한도__Max__150/1회__미국_달러_기준_" />
            </li>
            <li>
              5. <Trans i18nKey="page-sourcing:횟수_제한__매회" />
            </li>
            <li>
              6.{" "}
              <Trans
                i18nKey="page-sourcing:할인_쿠폰_사용할_수_있는_운송_조건___em_인코텀즈_E_F_C조건에서만_사용_가능합니다._/em__D조건에서는_쉽다의_역할이_없기에_사용_불가하나__향후_사용하실_수_있는_할인쿠폰은_발급_됩니다."
                components={{ em: <em /> }}
              />
            </li>
          </div>
        </Styled.faqContainer>
      ),
    },
    {
      title: (
        <Trans i18nKey="page-sourcing:즉시_결제_주문_건만_할인쿠폰이_적용되나요_" />
      ),
      desc: (
        <Styled.faq>
          <Trans i18nKey="page-sourcing:알리바바닷컴_내에서_주문_결제를_할_수_있는_방법은_크게_2가지입니다." />

          <br />
          <br />

          <ol>
            <li>
              1.{" "}
              <Trans i18nKey="page-sourcing:Buy_Now___상세페이지에서_상품_선정_및_수량_선택_후__즉시_결제하는_방법" />
            </li>
            <li>
              2.{" "}
              <Trans i18nKey="page-sourcing:Proposed_P/O___판매자_구매자_간_협의된_내용을_기반으로__판매자_가_주문서를_생성하는_방식" />
            </li>
          </ol>

          <br />

          <div>
            <em>
              <Trans i18nKey="page-sourcing:2가지_방식_모두_할인쿠폰이_적용됩니다." />
            </em>
            <br />
            <Trans i18nKey="page-sourcing:만약_할인쿠폰이_적용되지_않는다면__판매자가_주문서_생성하기_이전_15일_이내__쉽다_를_거쳐_알리바바닷컴으로_접속하지_않았기_때문입니다._이럴_경우에는_주문취소_후_다시_시도_부탁_드립니다." />
          </div>
        </Styled.faq>
      ),
    },
    {
      title: <Trans i18nKey="page-sourcing:쿠폰_유효기간이_궁금해요." />,
      desc: (
        <Styled.faq>
          <Trans
            i18nKey="page-sourcing:쿠폰_유효기간은__em_발급일로부터_1년_/em_입니다."
            components={{ em: <em /> }}
          />
        </Styled.faq>
      ),
    },
    {
      title: (
        <Trans i18nKey="page-sourcing:쿠폰_발행_시_환율은_어떻게_되나요_" />
      ),
      desc: (
        <Styled.faqWithBold>
          <Trans i18nKey="page-sourcing:당사에서_제공하는_쿠폰은__한화_KRW__로_발급됩니다._알리바바닷컴에서_한화가_아닌__타_통화로_결제하시는_경우_환율_적용에_대해_안내_드립니다." />

          <br />
          <br />

          <em>
            <Trans i18nKey="page-sourcing:환율_적용_기준" />
          </em>
          <br />
          <Trans
            i18nKey="page-sourcing:쿠폰_발행일의__하나은행_최초고시__환율_적용__소수점의_경우__1의_자리에서_반올림__br_/_알리바바_주문_결제_시점과_쿠폰_발행일의_시점_간_차이가_있을_수_있습니다._이_점_양해_부탁_드립니다."
            components={{ br: <br /> }}
          />

          <br />
          <br />

          <Trans
            i18nKey="page-sourcing:쿠폰_발행일__알리바바닷컴으로부터_주문_결제액_정보가_쉽다로_전달될_때_br_/_주문_결제액_이외_기타_개인정보는_접수되지_않습니다."
            components={{ br: <br /> }}
          />
        </Styled.faqWithBold>
      ),
    },
    {
      title: (
        <Trans i18nKey="page-sourcing:DAP_혹은_DDP_방식으로_상품을_소싱했어요._할인쿠폰_혜택을_받을_수_있을까요_" />
      ),
      desc: <DAPCaseAnswer />,
    },
  ];

  return <LandingSectionFaq data={FAQ_SECTION_DATA} />;
}
